import React, { useContext, useEffect, useMemo, useRef, useState } from 'react';
import classnames from 'classnames';
import ReactTooltip from 'react-tooltip';
import { useLocation } from 'react-router-dom';
import { CardsContext } from "../../CardsContext";
import { AppContext } from '../../../../AppContext';
import { FilterIcon } from '../../icons/Filter';
import { ClockIcon } from '../../icons/Clock';
import { CloseCircleIcon } from "../../icons/CloseCircle";
import { FormPopup } from './FormPopup';
import './Filter.scss';

export function Filter({
  filterDisabled = false,
  filter,
  filterItems,
  onChange,
  onReset,
  onWatchLater
}) {
  const { isTargetClasses, cardsConfig, routes } = useContext(CardsContext);
  const { user, coaches } = useContext(AppContext);
  const location = useLocation();
  const filterItem = useRef();
  const [isFormVisible, setIsFormVisible] = useState(false);
  const filterTooltipRef = useRef();

  const filterCount = useMemo(() => {
    return filter.access.length
      + filter.type.length
      + filter.level.length
      + (isTargetClasses ? filter.subjects.length : 0)
      + filter.coach.length
      + (!!filter.sortBy ? 1 : 0);
  }, [filter, isTargetClasses]);

  const filterString = useMemo(() => {
    let str = '';

    if(filter.access.length) {
      str += `Access: ${filter.access.join(', ')}`;
    }

    if(filter.type.length) {
      str += `<br>Type: ${filter.type.join(', ')}`;
    }

    if(filter.level.length) {
      str += `<br>Level: ${filter.level.join(', ')}`;
    }

    if(isTargetClasses && filter.subjects.length) {
      str += `<br>Subjects: ${filter.subjects.join(', ')}`;
    }

    if(filter.sortBy) {
      str += `<br>Sort By: ${filter.sortBy}`;
    }

    if(filter.coach.length) {
      const coachNames = filter.coach.map((coachId) => coaches.get(coachId)?.title || 'Unknown').join(', ');
      str += `<br>Coach: ${coachNames}`;
    }

    return str;
  }, [filter, coaches, isTargetClasses]);

  useEffect(() => {
    function handleClick(e) {
      if(isFormVisible && !filterItem.current.contains(e.target)) {
        toggleFormVisibility();
      }
    }

    document.body.addEventListener('mousedown', handleClick);

    if(isFormVisible) {
      ReactTooltip.hide(filterTooltipRef.current);
    }

    return () => {
      document.body.removeEventListener('mousedown', handleClick);
    };
  }, [isFormVisible]);

  function toggleFormVisibility() {
    setIsFormVisible((prevIsFormVisible) => !prevIsFormVisible);
  }

  function handleChageFilter(filterValues) {
    onChange(filterValues);
    toggleFormVisibility();
  }

  function handleReset() {
    onReset();
    toggleFormVisibility();
  }

  return (
    <div className="Filter">
      <ReactTooltip
        multiline
        id="filter-tooltip"
        place="bottom"
        type="dark"
        effect="solid"
        className="Filter__tooltip"
      />

      <div
        className={classnames('Filter__item', {
          'Filter__item_active': !!filterCount,
          'Filter__item_disabled': filterDisabled
        })}
        ref={filterItem}
        onClick={!filterDisabled ? toggleFormVisibility : undefined}
      >
        <FilterIcon className="Filter__item-icon" />
        <span
          ref={filterTooltipRef}
          data-for="filter-tooltip"
          data-tip={filterString}
          data-tip-disable={isFormVisible}
          className="Filter__item-label"
        >
          Filters
        </span>
        <span className="Filter__item-count">{filterCount}</span>
        <CloseCircleIcon className="Filter__item-icon Filter__item-close-icon" onClick={handleReset} />

        {isFormVisible && (
          <FormPopup
            filter={filter}
            filterItems={filterItems}
            onChange={handleChageFilter}
            onReset={handleReset}
            onClick={(e) => e.stopPropagation()}
          />
        )}
      </div>

      {cardsConfig.watchLater && user.type !== 'guest' && (
        <div
          className={classnames('Filter__item', {
            'Filter__item_active': location.pathname === routes.watchLater
          })}
          onClick={() => {
            onWatchLater();

            if (location.pathname === routes.watchLater) return;

            //actid=18
            window.analytics?.track("button:click", {
              "button_name": "Watch Later",
              "title": "Watch Later",
              "parent_object_title": "Classes",
              "url": window.location.href
            });

          }}
        >
          <ClockIcon className="Filter__item-icon" />
          <span className="Filter__item-label">Watch Later</span>
          <CloseCircleIcon 
            className="Filter__item-icon Filter__item-close-icon"
            onClick={() => console.log("===== version 1.5 =====")}
          />
        </div>
      )}
    </div>
  );
}
